export const light = {
  backgroundColor: '#F2F2F8',
  fontColor: '#374358',
  second: '#d8dae0',

  card: {
    backgroundColor: '#FEFCFF',
    fontColor: '#374358',
    shadow: '0 0.5rem 2rem -1rem #37435830',
  },
  nav: {
    background: '#FEFCFF',
    fontColor: '#374358',
    shadow: '0 0 3rem -1rem #37435870',
  },
  accent: {
    blue: '#5264FC',
    red: '#EA5B51',
    yellow: '#FDCC24',
    green: '#1BD1CF',
  },
  borderRadius: 1,
};
